function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import axios from 'axios';
import { createDPoPHeaders, isDPoPSupported } from './dpop';
import { OAUTH_CLIENTS } from '@edusense/shared-constants';
import { buildRefreshTokenRequestParams } from './refresh-request';
export { buildRefreshTokenRequestParams } from './refresh-request';
// --- Constants (필요한 것만) ---
var PROXY_TOKEN_ENDPOINT_PATH = '/api/proxy/token'; // 경로만 상수로 정의
// 중복 처리 방지를 위한 전역 상태
var ongoingRefreshOperations = new Map();
// --- Main Refresh Token Handler ---
export var handleRefreshTokenFlow = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(refreshToken, authServerUrl, existingTokenType) {
        var clientId, refreshKey, PROXY_TOKEN_ENDPOINT, refreshOperation;
        var _arguments = arguments;
        return _ts_generator(this, function(_state) {
            clientId = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : OAUTH_CLIENTS.APP_CLIENT.clientId;
            console.log('[RefreshTokenHandler] Refresh Token Flow 시도 (via Proxy)...', {
                clientId: clientId
            });
            if (!refreshToken) {
                console.warn('[RefreshTokenHandler] Refresh token이 제공되지 않았습니다.');
                return [
                    2,
                    {
                        success: false
                    }
                ];
            }
            // 중복 처리 방지: 동일한 토큰으로 진행 중인 갱신이 있는지 확인
            refreshKey = "".concat(refreshToken.substring(0, 20), "_").concat(authServerUrl, "_").concat(clientId);
            if (ongoingRefreshOperations.has(refreshKey)) {
                console.log('[RefreshTokenHandler] Refresh operation already in progress, waiting for existing operation');
                return [
                    2,
                    ongoingRefreshOperations.get(refreshKey)
                ];
            }
            PROXY_TOKEN_ENDPOINT = "".concat(authServerUrl).concat(PROXY_TOKEN_ENDPOINT_PATH);
            // 진행 중인 갱신 작업을 저장
            refreshOperation = _async_to_generator(function() {
                var _tokenResponse_data, _tokenResponse_data1, _tokenResponse_data2, _tokenResponse_data3, tokenParams, dpopSupported, useDPoP, headers, error, tokenResponse, errorData, _tokenResponse_data4, access_token, newRefreshToken, expires_in, token_type, error1, _error_response, _error_response1, _error_response_data, _error_response2, _error_response_data1, _error_response3, _error_response4;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                6,
                                ,
                                7
                            ]);
                            tokenParams = buildRefreshTokenRequestParams(refreshToken, clientId);
                            console.log('[RefreshTokenHandler] 프록시 토큰 갱신 요청 시작:', PROXY_TOKEN_ENDPOINT);
                            // DPoP 지원 확인
                            dpopSupported = isDPoPSupported();
                            useDPoP = dpopSupported && (existingTokenType === null || existingTokenType === void 0 ? void 0 : existingTokenType.toLowerCase()) === 'dpop';
                            // DPoP 헤더 생성 (선택적)
                            headers = {
                                'Content-Type': 'application/x-www-form-urlencoded'
                            };
                            if (!useDPoP) return [
                                3,
                                4
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                createDPoPHeaders('POST', PROXY_TOKEN_ENDPOINT, undefined, headers)
                            ];
                        case 2:
                            headers = _state.sent();
                            console.log('[RefreshTokenHandler] DPoP header added for refresh');
                            return [
                                3,
                                4
                            ];
                        case 3:
                            error = _state.sent();
                            console.warn('[RefreshTokenHandler] DPoP header creation failed:', error);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                4,
                                axios.post(PROXY_TOKEN_ENDPOINT, tokenParams, {
                                    headers: headers
                                })
                            ];
                        case 5:
                            tokenResponse = _state.sent();
                            console.log('[RefreshTokenHandler] 프록시 토큰 갱신 응답 수신:', {
                                hasAccessToken: Boolean((_tokenResponse_data = tokenResponse.data) === null || _tokenResponse_data === void 0 ? void 0 : _tokenResponse_data.access_token),
                                hasRefreshToken: Boolean((_tokenResponse_data1 = tokenResponse.data) === null || _tokenResponse_data1 === void 0 ? void 0 : _tokenResponse_data1.refresh_token),
                                tokenType: (_tokenResponse_data2 = tokenResponse.data) === null || _tokenResponse_data2 === void 0 ? void 0 : _tokenResponse_data2.token_type,
                                expiresIn: (_tokenResponse_data3 = tokenResponse.data) === null || _tokenResponse_data3 === void 0 ? void 0 : _tokenResponse_data3.expires_in
                            });
                            if (tokenResponse.data && _type_of(tokenResponse.data) === 'object' && 'error' in tokenResponse.data) {
                                console.error('[RefreshTokenHandler] Proxy returned an error:', tokenResponse.data);
                                errorData = tokenResponse.data;
                                if (errorData.error === 'invalid_grant') {
                                    console.warn('[RefreshTokenHandler] Refresh token is invalid or expired (via proxy).');
                                    return [
                                        2,
                                        {
                                            success: false,
                                            error: 'invalid_grant'
                                        }
                                    ];
                                }
                                return [
                                    2,
                                    {
                                        success: false,
                                        error: errorData.error
                                    }
                                ];
                            }
                            _tokenResponse_data4 = tokenResponse.data, access_token = _tokenResponse_data4.access_token, newRefreshToken = _tokenResponse_data4.refresh_token, expires_in = _tokenResponse_data4.expires_in, token_type = _tokenResponse_data4.token_type; // token_type 추가
                            if (!access_token) {
                                console.error('[RefreshTokenHandler] 프록시 응답에 access_token이 없습니다.', tokenResponse.data);
                                throw new Error('프록시 응답에 access_token이 없습니다.');
                            }
                            console.log('[RefreshTokenHandler] Refresh Token Flow 성공 (via Proxy).');
                            console.log('[RefreshTokenHandler] Token type:', token_type);
                            return [
                                2,
                                {
                                    success: true,
                                    accessToken: access_token,
                                    refreshToken: newRefreshToken,
                                    expiresIn: expires_in,
                                    tokenType: token_type // token_type 반환 추가
                                }
                            ];
                        case 6:
                            error1 = _state.sent();
                            console.error('[RefreshTokenHandler] Refresh Token Flow 실패 (Proxy):', error1);
                            if (axios.isAxiosError(error1)) {
                                ;
                                console.error('[RefreshTokenHandler] 프록시 토큰 갱신 오류 응답 (Axios):', (_error_response = error1.response) === null || _error_response === void 0 ? void 0 : _error_response.data, (_error_response1 = error1.response) === null || _error_response1 === void 0 ? void 0 : _error_response1.status);
                                if (((_error_response2 = error1.response) === null || _error_response2 === void 0 ? void 0 : (_error_response_data = _error_response2.data) === null || _error_response_data === void 0 ? void 0 : _error_response_data.error) === 'invalid_grant') {
                                    console.warn('[RefreshTokenHandler] Refresh token is invalid or expired (via proxy - Axios).');
                                    return [
                                        2,
                                        {
                                            success: false,
                                            error: 'invalid_grant'
                                        }
                                    ];
                                }
                                return [
                                    2,
                                    {
                                        success: false,
                                        error: ((_error_response3 = error1.response) === null || _error_response3 === void 0 ? void 0 : (_error_response_data1 = _error_response3.data) === null || _error_response_data1 === void 0 ? void 0 : _error_response_data1.error) || "proxy_request_failed_".concat((_error_response4 = error1.response) === null || _error_response4 === void 0 ? void 0 : _error_response4.status)
                                    }
                                ];
                            }
                            return [
                                2,
                                {
                                    success: false,
                                    error: 'network_error'
                                }
                            ];
                        case 7:
                            return [
                                2
                            ];
                    }
                });
            })().finally(function() {
                // 완료 후 진행 중인 작업에서 제거
                ongoingRefreshOperations.delete(refreshKey);
            });
            ongoingRefreshOperations.set(refreshKey, refreshOperation);
            return [
                2,
                refreshOperation
            ];
        });
    });
    return function handleRefreshTokenFlow(refreshToken, authServerUrl, existingTokenType) {
        return _ref.apply(this, arguments);
    };
}();
